import { render, staticRenderFns } from "./ShareModal.vue?vue&type=template&id=0aab2f33&scoped=true"
import script from "./ShareModal.vue?vue&type=script&lang=ts"
export * from "./ShareModal.vue?vue&type=script&lang=ts"
import style0 from "./ShareModal.vue?vue&type=style&index=0&id=0aab2f33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aab2f33",
  null
  
)

export default component.exports